import { render, staticRenderFns } from "./team3.vue?vue&type=template&id=6af749eb&scoped=true&"
import script from "./team3.vue?vue&type=script&lang=js&"
export * from "./team3.vue?vue&type=script&lang=js&"
import style0 from "./team3.vue?vue&type=style&index=0&id=6af749eb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af749eb",
  null
  
)

export default component.exports